/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

import { ReactNode } from 'react'

// Material Dashboard 2 PRO React TS components
import MDBox from 'components/MDBox'
import DashboardLayout from 'modules/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'modules/Navbars/DashboardNavbar'

// Declaring props types for BaseLayout
interface Props {
	stickyNavbar?: boolean
	children: ReactNode
}

function BaseLayout({ stickyNavbar, children }: Props): JSX.Element {
	return (
		<DashboardLayout>
			<DashboardNavbar absolute={!stickyNavbar} isMini />
			<MDBox mt={stickyNavbar ? 3 : 10}>{children}</MDBox>
		</DashboardLayout>
	)
}

// Declaring default props for BaseLayout
BaseLayout.defaultProps = {
	stickyNavbar: false,
}

export default BaseLayout
